import { createSlice } from '@reduxjs/toolkit';

// Helper functions for localStorage
const STORAGE_KEY = 'srv_total_bill_values';

const loadFromStorage = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        return stored ? JSON.parse(stored) : [];
    } catch (error) {
        console.error('Error loading total bill values from localStorage:', error);
        return [];
    }
};

const saveToStorage = (values) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(values));
    } catch (error) {
        console.error('Error saving total bill values to localStorage:', error);
    }
};

const totalBillSlice = createSlice({
    name: 'totalBill',
    initialState: {
        totalBillValues: loadFromStorage()
    },
    reducers: {
        addTotalBillValue: (state, action) => {
            const value = parseFloat(action.payload);
            if (!isNaN(value) && value > 0) {
                // Add to the end of the array (FIFO - First In, First Out)
                state.totalBillValues.push(value);
                // Keep only the last 25 values to prevent the list from growing too large
                if (state.totalBillValues.length > 25) {
                    state.totalBillValues = state.totalBillValues.slice(-25);
                }
                // Save to localStorage
                saveToStorage(state.totalBillValues);
            }
        },
        removeTotalBillValue: (state, action) => {
            const index = action.payload;
            if (index >= 0 && index < state.totalBillValues.length) {
                state.totalBillValues.splice(index, 1);
                // Save to localStorage
                saveToStorage(state.totalBillValues);
            }
        },
        clearTotalBillValues: (state) => {
            state.totalBillValues = [];
            // Save to localStorage
            saveToStorage(state.totalBillValues);
        },
        removeFirstTotalBillValue: (state) => {
            if (state.totalBillValues.length > 0) {
                state.totalBillValues.shift(); // Remove the first (oldest) value
                // Save to localStorage
                saveToStorage(state.totalBillValues);
            }
        }
    }
});

export const { addTotalBillValue, removeTotalBillValue, clearTotalBillValues, removeFirstTotalBillValue } = totalBillSlice.actions;
export default totalBillSlice.reducer;
